module.exports = __webpack_public_path__ + "static/media/paper_open_graph.660fe221.jpg";